import { TreeToolbar } from "slot-definitions"
import { FindTasks } from "authoring/routes/project/plugins/projectToolbar/find-tasks"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { TaskSimilarityItemCell } from "../../overwrite/task-correlator/task-similarity-item"
import { GroupContextMenu, ReferenceContextMenu } from "./group-context-menu"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { AddSchedulesButton } from "authoring/routes/project/plugins/add-schedules-button"
import { AddTasksButton } from "authoring/routes/project/plugins/add-tasks-button"
import { AddLeadingSummarySchedulesButton } from "authoring/routes/project/plugins/add-leading-summary-schedules-button"
import { ScheduleRowCell } from "../../add/add-group-schedule-row"
import { EditAddedTaskButton } from "authoring/routes/project/plugins/edit-added-task-button"
import { TaskRowUpperButton } from "../../add/add-group-task-row"
import { AddIntroSchedulesButton } from "authoring/routes/project/plugins/add-intro-schedules-button"
import { DeleteGroup } from "authoring/routes/project/plugins/delete-group"
import { DeleteGroupLegislation } from "../../delete-group-legislation"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

TreeToolbar.plug(
    <Secure
        if={(c) => c.isOverwrite && !isLockedToLegacy(c.target.phase)}
        demand={AUTHORING_EDIT_SCHEDULES_DEMAND}
        fallback={<Frag />}
        priority={30}
    >
        <FindTasks variant="contained" />
    </Secure>
)

TaskSimilarityItemCell.plug(
    <Secure if={(c) => c.isOverwrite} demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
        <ContextMenuBar type="overwriteSimilarTask" buttonSx={{ mx: 0, px: 0 }} size="large" />
    </Secure>
)

TreeToolbar.plug(
    <Secure
        if={(c) => c.isAdd && !isLockedToLegacy(c.target.phase)}
        demand={AUTHORING_EDIT_SCHEDULES_DEMAND}
        fallback={<Frag />}
        priority={30}
    >
        <AddSchedulesButton />
    </Secure>
)
TreeToolbar.plug(
    <Secure
        if={(c) => c.isLeadingSummary && !isLockedToLegacy(c.target.phase)}
        demand={AUTHORING_EDIT_SCHEDULES_DEMAND}
        fallback={<Frag />}
        priority={30}
    >
        <AddLeadingSummarySchedulesButton />
    </Secure>
)
TreeToolbar.plug(
    <Secure
        if={(c) => c.isAdd && !isLockedToLegacy(c.target.phase)}
        demand={AUTHORING_EDIT_SCHEDULES_DEMAND}
        fallback={<Frag />}
        priority={50}
    >
        <AddTasksButton />
    </Secure>
)

ScheduleRowCell.plug(
    <Secure if={(c) => c.isAdd} demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
        <ContextMenuBar type="addTasks" buttonSx={{ mx: 0, px: 0 }} size="large" />
    </Secure>
)

TaskRowUpperButton.plug(
    <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
        <EditAddedTaskButton />
    </Secure>
)

TreeToolbar.plug(
    <Secure
        if={(c) => c.isIntroduction && !isLockedToLegacy(c.target.phase)}
        demand={AUTHORING_EDIT_SCHEDULES_DEMAND}
        fallback={<Frag />}
        priority={30}
    >
        <AddIntroSchedulesButton />
    </Secure>
)

GroupContextMenu.plug(<DeleteGroup />)
ReferenceContextMenu.plug(
    <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
        <DeleteGroupLegislation />
    </Secure>
)
